(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BSAupdatedcalculator"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {

    var areaHeaders = {
      'face-neck': 'Face & Neck',
      'arm': 'Each Arm',
      'leg': 'Each Leg'
    };

    document.querySelectorAll('.BSA-area-toggle').forEach(function(toggle) {
      toggle.addEventListener('click', function() {
        toggle.classList.toggle('active');
      });
    });

    document.getElementById('BSA-calc-btn').addEventListener('click', function() {
      var weight = parseFloat(document.getElementById('BSA-weight').value);
      var height = parseFloat(document.getElementById('BSA-height').value);
      var selected = document.querySelectorAll('.BSA-area-toggle.active');
      var errorEl = document.getElementById('BSA-error');

      if (isNaN(weight) || isNaN(height)) {
        errorEl.innerHTML = "<div class='BSA-error'>Please enter valid numbers for weight and height.</div>";
        return;
      }
      if (selected.length === 0) {
        errorEl.innerHTML = "<div class='BSA-error'>Please select at least one body area.</div>";
        return;
      }

      errorEl.innerHTML = '';

      var bsa = 0.007184 * Math.pow(weight, 0.425) * Math.pow(height, 0.725);
      var html = '';

      selected.forEach(function(toggle) {
        var area = toggle.getAttribute('data-area');
        var fraction = parseFloat(toggle.getAttribute('data-fraction'));
        var surfaceArea = bsa * 10000 * fraction;
        var ml = (surfaceArea * 2) / 1000;
        var s1 = Math.round(ml / 1);
        var s125 = Math.round(ml / 1.25);

        var scoop1Html = s1 > 0 ? "<div class='BSA-scoop-item'><span class='BSA-scoop-dot yellow'></span><span class='BSA-scoop-count'>" + s1 + "</span></div>" : '';
        var scoop125Html = s125 > 0 ? "<div class='BSA-scoop-item'><span class='BSA-scoop-dot black'></span><span class='BSA-scoop-count'>" + s125 + "</span></div>" : '';
        var orHtml = (s1 > 0 && s125 > 0) ? "<div class='BSA-scoop-or'>OR</div>" : '';

        html +=
          "<div class='BSA-result-row'>" +
          "<div class='BSA-result-area-name'>" + areaHeaders[area] + "</div>" +
          "<div class='BSA-scoop-row'>" +
          scoop1Html + orHtml + scoop125Html +
          "</div>" +
         // "<div class='BSA-result-ml'>Total: " + ml.toFixed(2) + " ml</div>" +
          "</div>";
      });

      document.getElementById('BSA-results-body').innerHTML = html;
      document.getElementById('BSA-results').classList.remove('BSA-hidden');
      document.getElementById('BSA-results').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-section"] && !Shopify.designMode) return;
  try {
    
const tabs = document.querySelectorAll('.benefits-tab');
const contents = document.querySelectorAll('.benefits-content');

tabs.forEach(tab => {
  tab.addEventListener('click', () => {
    tabs.forEach(t => t.classList.remove('active'));
    tab.classList.add('active');

    const target = tab.dataset.tab;
    contents.forEach(c => {
      c.classList.toggle('active', c.id === target);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-chatbot-name-poll"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".bordered-button");
    //const emailInput = document.querySelector("input[name='email_phonenumber']");
    const guessCount = document.getElementById("guess_count");
    const successDiv = document.getElementById("feedback-result-success");
    const errorDiv = document.getElementById("feedback-result-error");

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    buttons.forEach(button => {
        button.addEventListener("click", function () {
            // const email = emailInput.value.trim();
            
            // if (!email) {
            //     errorDiv.textContent = "Email is required!";
            //     errorDiv.style.display = "block";
            //     return;
            // }
            
            // if (!isValidEmail(email)) {
            //     errorDiv.textContent = "Please enter a valid email address!";
            //     errorDiv.style.display = "block";
            //     return;
            // }
            
            // Disable all buttons
            buttons.forEach(btn => {
                btn.disabled = true;
                btn.classList.add("disabled-button");
            });

            // Highlight the clicked button
            this.classList.add("selected-button");

            // Fetch the data-value
            const selectedValue = this.getAttribute("data-value");
            const InputData = {
                formId: "chatbotname",
                userId: ShopifyAnalytics.lib.user().traits().uniqToken,
                data: { 
                    botname: selectedValue,
                    //email: email // Include email in the API request
                }
            };

            // Submit to API
            fetch('https://api.chosenstore.in/chosen-form', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(InputData)
            })
            .then(response => response.json())
            .then(data => {
                if (data.message == "Success") {
                    //successDiv.textContent = "Thank you for voting! We’re so glad you’re part of this journey - we’ll reveal the chosen name very soon 💛";
                    successDiv.style.display = "block";
                  errorDiv.style.display = "none";
                } else {
                  successDiv.style.display = "none";
                    errorDiv.textContent = "Failed! Please try again!";
                    errorDiv.style.display = "block";
                }
            })
            .catch(error => {
                console.error("Error:", error);
                errorDiv.textContent = "Something went wrong. Please try again!";
                errorDiv.style.display = "block";
            });
        });
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-conclave-dresscode"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll('.color-btn');
  const submitBtn = document.getElementById('submit-poll');
  const successDiv = document.getElementById('feedback-result-success');
  const errorDiv = document.getElementById('feedback-result-error');

  let selectedValues = [];

  // Select / Unselect buttons
  buttons.forEach(button => {
    button.addEventListener('click', function () {
      const value = this.getAttribute('data-value');

      if (this.classList.contains('selected-button')) {
        this.classList.remove('selected-button');
        selectedValues = selectedValues.filter(v => v !== value);
      } else {
        this.classList.add('selected-button');
        selectedValues.push(value);
      }

      // Enable / disable submit button
      submitBtn.disabled = selectedValues.length === 0;
    });
  });

  // Submit button click
  submitBtn.addEventListener('click', function () {
    if (selectedValues.length === 0) return;

    submitBtn.disabled = true;
    submitBtn.textContent = "Submitting...";

    const InputData = {
      formId: 'ConclaveDresscode2026',
      userId: ShopifyAnalytics.lib.user().traits().uniqToken,
      data: {
        flavour: selectedValues   // ARRAY
      }
    };

    fetch('https://api.chosenstore.in/chosen-form/poll/conclave-dresscode-poll-2026', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(InputData)
    })
    .then(res => res.json())
    .then(data => {
      if (data.status === 'success') {
        successDiv.textContent = "Thank you for voting 💛";
        successDiv.style.display = 'block';
        errorDiv.style.display = 'none';

        // Lock selections after submit (optional)
        buttons.forEach(btn => btn.disabled = true);
      } else {
        errorDiv.textContent = data.message;
        errorDiv.style.display = 'block';
        submitBtn.disabled = false;
        submitBtn.textContent = "Submit";
      }
    })
    .catch(() => {
      errorDiv.textContent = "Something went wrong. Please try again!";
      errorDiv.style.display = 'block';
      submitBtn.disabled = false;
      submitBtn.textContent = "Submit";
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-conclave-name-poll"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll('.bordered-button');
    const successDiv = document.getElementById('feedback-result-success');
    const errorDiv = document.getElementById('feedback-result-error');

    buttons.forEach(button => {
      button.addEventListener('click', function () {
        // Disable all buttons
        buttons.forEach(btn => {
          btn.disabled = true;
          btn.classList.add('disabled-button');
        });

        // Highlight the clicked button
        this.classList.add('selected-button');

        const selectedValue = this.getAttribute('data-value');
        const InputData = {
          formId: 'ConclaveNamePoll2026',
          userId: ShopifyAnalytics.lib.user().traits().uniqToken,
          data: { flavour: selectedValue }
        };

        fetch('https://api.chosenstore.in/chosen-form/poll/conclave-name-poll-2026', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(InputData)
        })
        .then(res => res.json())
        .then(data => {
          if (data.status === 'success') {
            successDiv.textContent = data.flavour_count == 0
              ? "Thank you for voting 💛"
              : `Thank you for voting 💛`;
            successDiv.style.display = 'block';
            errorDiv.style.display = 'none';
          } else {
            successDiv.style.display = 'none';
            errorDiv.textContent = data.message;
            errorDiv.style.display = 'block';
          }
        })
        .catch(() => {
          errorDiv.textContent = 'Something went wrong. Please try again!';
          errorDiv.style.display = 'block';
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-guess-tagline"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".bordered-button");
    const emailInput = document.querySelector("input[name='email_phonenumber']");
    const guessCount = document.getElementById("guess_count");
    const successDiv = document.getElementById("feedback-result-success");
    const errorDiv = document.getElementById("feedback-result-error");

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    buttons.forEach(button => {
        button.addEventListener("click", function () {
            const email = emailInput.value.trim();
            
            if (!email) {
                errorDiv.textContent = "Email is required!";
                errorDiv.style.display = "block";
                return;
            }
            
            if (!isValidEmail(email)) {
                errorDiv.textContent = "Please enter a valid email address!";
                errorDiv.style.display = "block";
                return;
            }
            
            // Disable all buttons
            buttons.forEach(btn => {
                btn.disabled = true;
                btn.classList.add("disabled-button");
            });

            // Highlight the clicked button
            this.classList.add("selected-button");

            // Fetch the data-value
            const selectedValue = this.getAttribute("data-value");
            const InputData = {
                formId: "CollagenGuessTagLine",
                userId: ShopifyAnalytics.lib.user().traits().uniqToken,
                data: { 
                    flavour: selectedValue,
                    email: email // Include email in the API request
                }
            };

            // Submit to API
            fetch('https://api.chosenstore.in/chosen-form/poll/collagen-flavour', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(InputData)
            })
            .then(response => response.json())
            .then(data => {
                if (data.message == "Success") {
                    successDiv.textContent = data.flavour_count == 0 
                        ? "Thanks for guessing! You're the first one who chose this—stay tuned for the big reveal!"
                        : `Thanks for guessing! You're with ${data.flavour_count} others who chose this—stay tuned for the big reveal!`;
                    successDiv.style.display = "block";
                  errorDiv.style.display = "none";
                } else {
                  successDiv.style.display = "none";
                    errorDiv.textContent = "Failed! Please try again!";
                    errorDiv.style.display = "block";
                }
            })
            .catch(error => {
                console.error("Error:", error);
                errorDiv.textContent = "Something went wrong. Please try again!";
                errorDiv.style.display = "block";
            });
        });
    });
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-guesstheflavour"]) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    const buttons = document.querySelectorAll(".bordered-button");
    const emailInput = document.querySelector("input[name='email_phonenumber']");
    const guessCount = document.getElementById("guess_count");
    const successDiv = document.getElementById("feedback-result-success");
    const errorDiv = document.getElementById("feedback-result-error");

    function isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    buttons.forEach(button => {
        button.addEventListener("click", function () {
            const email = emailInput.value.trim();
            
            if (!email) {
                errorDiv.textContent = "Email is required!";
                errorDiv.style.display = "block";
                return;
            }
            
            if (!isValidEmail(email)) {
                errorDiv.textContent = "Please enter a valid email address!";
                errorDiv.style.display = "block";
                return;
            }
            
            // Disable all buttons
            buttons.forEach(btn => {
                btn.disabled = true;
                btn.classList.add("disabled-button");
            });

            // Highlight the clicked button
            this.classList.add("selected-button");

            // Fetch the data-value
            const selectedValue = this.getAttribute("data-value");
            const InputData = {
                formId: "CollagenGuessFlavour",
                userId: ShopifyAnalytics.lib.user().traits().uniqToken,
                data: { 
                    flavour: selectedValue,
                    email: email // Include email in the API request
                }
            };

            // Submit to API
            fetch('https://api.chosenstore.in/chosen-form/poll/collagen-flavour', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(InputData)
            })
            .then(response => response.json())
            .then(data => {
                if (data.message == "Success") {
                    successDiv.textContent = data.flavour_count == 0 
                        ? "Thanks for guessing! You're the first one who chose this—stay tuned for the big reveal!"
                        : `Thanks for guessing! You're with ${data.flavour_count} others who chose this—stay tuned for the big reveal!`;
                    successDiv.style.display = "block";
                  errorDiv.style.display = "none";
                } else {
                  successDiv.style.display = "none";
                    errorDiv.textContent = "Failed! Please try again!";
                    errorDiv.style.display = "block";
                }
            })
            .catch(error => {
                console.error("Error:", error);
                errorDiv.textContent = "Something went wrong. Please try again!";
                errorDiv.style.display = "block";
            });
        });
    });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-tor-coffee-flavour"]) return;
  try {
    
 document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".tor-collagen-flavour-poll-wrap .list-collections__item");
  const successDiv = document.getElementById("feedback-result-success");
  const errorDiv = document.getElementById("feedback-result-error");
  const tryAgainButton = document.querySelector(".btn.btn--solid"); // Assuming only one Try Again button
  let hasVoted = false;

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  buttons.forEach(button => {
    button.addEventListener("click", function () {
      if (hasVoted) return;

      hasVoted = true;
      const userId = ShopifyAnalytics.lib.user().traits().uniqToken;

      // Disable buttons and clean previous styles
      buttons.forEach(btn => {
        btn.style.pointerEvents = "none";
        btn.classList.add("disabled-click");
        btn.classList.remove("selected-button");

        const oldOverlay = btn.querySelector(".vote-overlay");
        if (oldOverlay) oldOverlay.remove();
      });

      this.classList.add("selected-button");

      const selectedValue = this.querySelector(".list-collections__item__title")?.textContent.trim();
      const selectedValueNormalize = selectedValue.toLowerCase();

      // Show related flavor info
      document.querySelectorAll('.tor-collagen-flavor-info').forEach(el => {
        const classList = Array.from(el.classList);
        const match = classList.find(cls => cls.includes('-flavor') && cls.includes(selectedValueNormalize));
        if (match) {
          el.style.display = 'block';
          tryAgainButton.style.display = 'inline-block'; // Show Try Again button
        }
      });

      const target = document.querySelector('.tor-collagen-flavor-section');
      const offset = 100;
      const top = target.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: 'smooth' });

      const InputData = {
        formId: "TorCollagenFlavourPoll",
        userId: userId,
        data: {
          flavour: selectedValue
        }
      };

      fetch('https://api.chosenstore.in/chosen-form/poll/tor-collagen-flavour-poll', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(InputData)
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === "success") {
          // successDiv.style.display = "block"; // Optional
        } else {
          // errorDiv.textContent = "Submission failed.";
          // errorDiv.style.display = "block";
        }
      })
      .catch(error => {
        console.error("Error:", error);
        errorDiv.textContent = "Something went wrong. Please try again!";
        errorDiv.style.display = "block";
      });
    });
  });

  // Try Again Button Logic
  tryAgainButton.addEventListener("click", function () {
    // Hide all flavor info sections
    document.querySelectorAll(".tor-collagen-flavor-info").forEach(el => {
      el.style.display = "none";
    });

    // Enable all buttons and remove classes
    buttons.forEach(button => {
      button.style.pointerEvents = "auto";
      button.classList.remove("disabled-click");
      button.classList.remove("selected-button");

      const oldOverlay = button.querySelector(".vote-overlay");
      if (oldOverlay) oldOverlay.remove();
    });

    // Hide Try Again button
    this.style.display = "none";

    // Allow re-voting
    hasVoted = false;

    // Hide feedback messages (optional)
    successDiv.style.display = "none";
    errorDiv.style.display = "none";

      // 🔽 Smooth scroll back to poll
  const pollSection = document.querySelector('.tor-collagen-flavour-poll-wrap');
  if (pollSection) {
    const offset = 100;
    const top = pollSection.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  }
  });
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["redcovery-discount"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  // Form Submission Handling
  document.getElementById("discount_form").addEventListener("submit", function(event) {
        event.preventDefault();
        let form = event.target;
        let formData = new FormData(form);
        let messageBox = document.getElementById("discount_message");
        let phoneInput = form.querySelector('[name="phone_number"]');
        let phoneNumber = phoneInput.value.trim();
        let phoneRegex = /^[6-9]\d{9}$/;

         // JavaScript validation for Indian phone number
      if (!phoneRegex.test(phoneNumber)) {
          messageBox.style.display = "block";
          messageBox.innerHTML = `<p style="color: red; font-weight: bold;">
              The phone number must be a valid 10-digit Indian mobile number starting with 6, 7, 8, or 9.
          </p>`;
          return; // Stop form submission
      }
 // Show loader
      document.getElementById('loader-discount').style.display = 'flex';
   fetch("https://cpos.chosenstore.in/api/generate-product-discount", {
  //fetch("http://127.0.0.1:8000/api/generate-product-discount", {
        method: "POST",
        body: formData,
        headers: {
            "Accept": "application/json"
        }
    })
    .then(response => response.json())
    .then(data => {
        messageBox.style.display = "block";
        messageBox.innerHTML = "";
        // Hide loader
        document.getElementById('loader-discount').style.display = 'none';
        if (data.success) {
            messageBox.innerHTML = `<p style="color: green; font-weight: bold;">
                ${data.message}
            </p>`;
            form.reset();
        } else if (data.errors) {
            let errorMessages = Object.values(data.errors).map(error => `<p style="color: red; font-weight: bold;">${error}</p>`).join("");
            messageBox.innerHTML = errorMessages;
        } else {
            messageBox.innerHTML = `<p style="color: red; font-weight: bold;">
                ${data.message}
            </p>`;
        }
    })
    .catch(error => {
        messageBox.innerHTML = `<p style="color: red; font-weight: bold;">
            Something went wrong, please try again.
        </p>`;
        messageBox.style.display = "block";
      // Hide loader on error
      document.getElementById('loader-discount').style.display = 'none';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-custom-tolstoy-app-block"] && !Shopify.designMode) return;
  try {
    
  // Run the script after the page has fully loaded
  window.addEventListener('load', function () {
    // custom code to listen tolstoy app load event and hide loader after load
    const hideTolstoySkeleton = () => {
    const loader = document.querySelector('.tolstoy-carousel-wrap .loader-skeleton');
    if (loader) loader.style.display = 'none';
  };

  // 1. MutationObserver: watches for the actual carousel to load
  const observer = new MutationObserver(() => {
    const tolstoyLoaded = document.querySelector('.tolstoy-carousel-container');
    if (tolstoyLoaded) {
      hideTolstoySkeleton();
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  // 2. Tolstoy postMessage event listener
  window.addEventListener("message", (message) => {
    if (message.data && message.data.name === 'tolstoyStarted') {
      //console.log("Tolstoy Started:", message.data);
      hideTolstoySkeleton();
    }
  });
  // end custom code to listen tolstoy app load event and hide loader after load
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-shade-products-slider"] && !Shopify.designMode) return;
  try {
    
   window.addEventListener('DOMContentLoaded', function () {
  const firstShade = document.querySelector('.shade-color');
  const selector = document.getElementById('shade-selector');
  const picker = document.getElementById('shade-picker');

  if (firstShade && selector && picker) {
    firstShade.classList.add('active');

    const shadeRect = firstShade.getBoundingClientRect();
    const pickerRect = picker.getBoundingClientRect();
    const leftPosition = shadeRect.left - pickerRect.left + (shadeRect.width / 2);
    selector.style.left = `${leftPosition}px`;
  }

  // Set border on the first .product-grid-item by default
  const firstProduct = document.querySelector('.shade-slider-click .product-grid-item');
  if (firstProduct) {
    firstProduct.classList.add('selected-shade');
  }
});

// Product click logic
document.querySelectorAll('.shade-slider-click .product-grid-item').forEach(item => {
  item.addEventListener('click', function (e) {
    e.preventDefault(); // prevent anchor inside from being triggered

    const selectedShade = this.getAttribute('data-shade');
    const selector = document.getElementById('shade-selector');
    const picker = document.getElementById('shade-picker');

    // Remove previous selections
    document.querySelectorAll('.shade-color').forEach(sc => sc.classList.remove('active'));
    document.querySelectorAll('.product-grid-item').forEach(p => p.classList.remove('selected-shade'));

    // Move shade-selector
    const matchingShade = document.querySelector(`.shade-color p[data-shade-number="${selectedShade}"]`);
    if (matchingShade && selector && picker) {
      const shadeBlock = matchingShade.closest('.shade-color');
      shadeBlock.classList.add('active');

      const shadeRect = shadeBlock.getBoundingClientRect();
      const pickerRect = picker.getBoundingClientRect();
      const leftPosition = shadeRect.left - pickerRect.left + (shadeRect.width / 2);
      selector.style.left = `${leftPosition}px`;
    }

    // Add border to selected product
    this.classList.add('selected-shade');
  });
});


 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["smoo-candy-discount"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

    const form = document.getElementById("discount_form");
    const loader = document.getElementById("loader-discount");
    const messageBox = document.getElementById("discount_message");

    form.addEventListener("submit", function (event) {
        event.preventDefault();

        let formData = new FormData(form);

        // Show loader
        loader.style.display = "flex";

        fetch("https://cpos.chosenstore.in/api/smo-generate-product-discount", {
        // fetch("http://127.0.0.1:8000/api/smo-generate-product-discount", {
            method: "POST",
            body: formData,
            headers: {
                "Accept": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {

                loader.style.display = "none"; // Hide loader
                messageBox.style.display = "block";

                if (data.success) {
                    messageBox.innerHTML = `
                        <p style="color: green; font-weight: bold;">
                            ${data.message}
                        </p>`;
                    form.reset();
                } else if (data.errors) {
                    let errorMessages = Object.values(data.errors)
                        .map(err => `<p style="color: red; font-weight: bold;">${err}</p>`)
                        .join("");
                    messageBox.innerHTML = errorMessages;
                } else {
                    messageBox.innerHTML = `
                        <p style="color: red; font-weight: bold;">
                            ${data.message}
                        </p>`;
                }
            })
            .catch(error => {
                loader.style.display = "none";
                messageBox.style.display = "block";
                messageBox.innerHTML = `
                    <p style="color: red; font-weight: bold;">
                        Something went wrong, please try again.
                    </p>`;
            });

    });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utm-test-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value) {
    // 20-hour max-age matches the site-wide UTM cookie set in assets/custom.js —
    // keep both in sync so this section doesn't reset it back to a session cookie.
    document.cookie = name + '=' + encodeURIComponent(value) + ';path=/;max-age=' + (60 * 60 * 20);
  }

  document.querySelectorAll('.utm-test-section').forEach(function (section) {
    var param = section.getAttribute('data-utm-param');
    var expectedValue = section.getAttribute('data-utm-value');
    var cookieName = 'utm_seen_' + param;

    // Check URL first, then cookie
    var value = new URLSearchParams(window.location.search).get(param);

    if (value !== null) {
      setCookie(cookieName, value);
    } else {
      value = getCookie(cookieName);
    }

    var matches = false;
    if (value !== null) {
      matches = expectedValue ? value === expectedValue : true;
    }

    section.style.display = matches ? '' : 'none';
  });

  // Remove .product__block.ocs-wrapper when utm_campaign=exclusive
  var utmCampaign = new URLSearchParams(window.location.search).get('utm_campaign');

  if (utmCampaign !== null) {
    setCookie('utm_seen_utm_campaign', utmCampaign);
  } else {
    utmCampaign = getCookie('utm_seen_utm_campaign');
  }

  if (utmCampaign === 'exclusive') {
    document.querySelectorAll('.product__block.ocs-wrapper').forEach(function (el) {
      el.remove();
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
